export default __webpack_public_path__ + "static/The-Vault-a4a38bc26670767687ff738ba8fb48d8.png";